import { useDeleteModel } from "./api/deleteModel";
import { Button } from "reactstrap";


const DeleteModel = ({handleCloseModal, modelId}: DeleteModelProps)  => {
  
  const deleteModelMutation = useDeleteModel({ modelId});
  const handleSubmit = async (): Promise<void> => {
    deleteModelMutation.mutateAsync({ 
      modelId: modelId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε το Είδος Συσκευής;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeleteModelProps{
  modelId: number;
  handleCloseModal: () => void;
}

export default DeleteModel;